export default __webpack_public_path__ + "silly-explosion-a97d885a493068a1571c4aa724fae0f2.mp3";